import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../utils/sagas";
import {apiPost} from "./client";

export const useNSFW = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, state) {
        yield call(apiPost, `/api/v2/action/nsfw`, {
            id,
            nsfw: state,
        });
    }, []));
};
